import { Bank, PreferredAccountFormat } from "Infrastructure/Api/Api";
import { Resources } from "Infrastructure/Translation/Resources";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import { z } from "zod";

const validationMessagesResource = Resources.base.bankDetail.validationMessages;

export const getCompanyBankDetailCreateForm = (
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) => {
	return z.object({
		name: z.string().nonempty({ message: t(validationMessagesResource.name) }),
		bankName: z.nativeEnum(Bank),
		bankAccount: z
			.string()
			.nonempty({ message: t(validationMessagesResource.bankAccount) }),
		iban: z.string().nonempty({ message: t(validationMessagesResource.iban) }),
		bankCode: z
			.string()
			.nonempty({ message: t(validationMessagesResource.bankCode) }),
		preferredAccountFormat: z.nativeEnum(PreferredAccountFormat),
	});
};

export type CompanyBankDetailCreateFormModel = z.infer<
	ReturnType<typeof getCompanyBankDetailCreateForm>
>;
